import {
	DialogCompat as Dialog,
	DialogType,
	IDialogContentProps,
	IDialogProps,
} from 'components/FluentUICompat';
import {useTranslation} from 'react-i18next';
import React from 'react';
import {RequirementChangeType} from 'types';
import {
	SendApprovalDialogChangeTypeMode,
	WORKFLOW_DIALOG_MODAL_PROPS,
	WorkflowChangeTypeDropdown,
	WorkflowDialogFooter,
	WorkflowReasonField,
} from './WorkflowDialogShared';

export type ConfirmWithoutApprovalDialogProps = Omit<
	IDialogProps,
	'modalProps'
> & {
	onConfirm: () => void;
	requirementName: string;
	changeType: RequirementChangeType;
	setChangeType: (changeType: RequirementChangeType) => void;
	changeTypeMode: SendApprovalDialogChangeTypeMode;
	reason: string;
	setReason: (res: string) => void;
};

export const ConfirmWithoutApproval: React.FC<
	ConfirmWithoutApprovalDialogProps
> = ({
	requirementName,
	changeType,
	setChangeType,
	changeTypeMode,
	reason,
	setReason,
	...props
}) => {
	const {t} = useTranslation('features/requirements', {
		keyPrefix: 'WorkflowDialog',
	});

	const [submitDisabled, setSubmitDisabled] = React.useState(
		changeTypeMode === SendApprovalDialogChangeTypeMode.Show &&
			changeType === RequirementChangeType.None,
	);

	const dismiss = () => {
		props?.onDismiss?.();
	};

	const dialogContentProps: IDialogContentProps = React.useMemo(
		() => ({
			type: DialogType.normal,
			title: t('CompleteWithoutApproval'),
			subText: t('ConfirmWitoutApprovalText', {name: requirementName}),
		}),
		[],
	);

	React.useEffect(() => {
		const changeTypeRequired =
			changeTypeMode === SendApprovalDialogChangeTypeMode.Show &&
			changeType === RequirementChangeType.None;
		setSubmitDisabled(changeTypeRequired);
	}, [changeType, changeTypeMode]);

	return (
		<Dialog
			dialogContentProps={dialogContentProps}
			{...props}
			onDismiss={dismiss}
			modalProps={WORKFLOW_DIALOG_MODAL_PROPS}
		>
			<>
				<WorkflowChangeTypeDropdown
					changeType={changeType}
					changeTypeMode={changeTypeMode}
					setChangeType={setChangeType}
				/>
				<WorkflowReasonField setReason={setReason} />
				<WorkflowDialogFooter
					onConfirm={props.onConfirm}
					onDismiss={dismiss}
					submitDisabled={submitDisabled}
				/>
			</>
		</Dialog>
	);
};
